import { render, staticRenderFns } from "./study.vue?vue&type=template&id=dd2402e8&scoped=true&"
import script from "./study.vue?vue&type=script&lang=js&"
export * from "./study.vue?vue&type=script&lang=js&"
import style0 from "./study.vue?vue&type=style&index=0&id=dd2402e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd2402e8",
  null
  
)

export default component.exports